document.addEventListener('DOMContentLoaded', function () {
    /* site switcher */
    const siteSwitcher = document.querySelectorAll('.js-site-switcher');
    siteSwitcher.forEach(switcher => {
        switcher.addEventListener('click', () => {
            switcher.classList.toggle('opened');
        });
    });

    window.addEventListener('click', e => {
        const target = e.target;
        if (!target.closest('.site-switcher') && !target.closest('.js-site-switcher__item')) {
            siteSwitcher.forEach(switcher => {
                switcher.classList.remove('opened');
            });
        }
    });
    
    /* parallaxes */
    const images = document.querySelectorAll('.parallaxed');
    const parallaxes = [];

    if (simpleParallax && images.length) {
        images.forEach((img, i) => {
            const scale = img.getAttribute('data-scale');

            parallaxes.push(new simpleParallax(img, {
                delay: parseFloat((1 + (i * Math.random())).toFixed(2)),
                transition: "cubic-bezier(0,0,0,1)",
                scale: scale ? parseFloat(scale) : Math.random() + 3,
                overflow: true
            }));
        });

        parallaxes.forEach((par) => {
            if (par.lastPosition === -1) {
                par.refresh()
            }
        });
    }

    /*curve text*/
    const wrapTexts = document.querySelectorAll('.wrapped');
    let loadingInstafeedLimit = 1000;

    let observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
                const dir = entry.target.getAttribute('dir');
                const rad = entry.target.getAttribute('rad') || 300;

                new CircleType(entry.target)
                    .dir((dir === 'top') ? 1 : -1)
                    .radius((dir === 'top') ? (rad || 300) : 600);
            });
        },
        {rootMargin: "0px 0px -200px 0px"});

    wrapTexts.forEach((text) => {
        observer.observe(text);
    });

    /* handle instafeed */
    const waitForInstafeed = () => {
        const instafeedHeader = document.querySelector('#insta-feed h2');

        if (instafeedHeader) {
            const instaLink = document.createElement('A');

            instaLink.href = document.querySelector('A[href*="instagram.com"]');
            instaLink.className = 'insta-link'; /* ??? */
            instaLink.textContent = 'Follow us on Instagram';
            instaLink.target = '_blank';
            instafeedHeader.after(instaLink);
            instafeedHeader.setAttribute('dir', 'top');
            observer.observe(instafeedHeader);
        } else if (loadingInstafeedLimit > 0) {
            loadingInstafeedLimit--;
            setTimeout(waitForInstafeed, 200);
        }
    }

    waitForInstafeed();

    /* infinite carousel */
    const carouselList = document.querySelectorAll('.infinite-loop ul');
    const updateElements = (list) => {
        const initialLength = parseInt(list.getAttribute('data-length'), 10);
        const items = list.querySelectorAll('LI');
        const length = items.length;
        const nextItem = items[length - initialLength];
        const rect = nextItem.getBoundingClientRect();
        let fullWidth = 0;

        if (rect.left < 0 && rect.right < 0) {
            const clone = nextItem.cloneNode(true);

            list.appendChild(clone);
        }

        setTimeout(() => {
            requestAnimationFrame(() => updateElements(list));
        }, 500);
    };

    carouselList.forEach((list) => {
        list.setAttribute('data-length', list.querySelectorAll('LI').length);
        updateElements(list);
    });

    /* product__quantity +/- */
    const inputs = document.querySelectorAll('.product__quantity');
    const wrap = (toWrap, wrapper) => {
        wrapper = wrapper || document.createElement('div');
        wrapper.classList.add('input-number-wrapper');
        toWrap.parentNode.appendChild(wrapper);

        return wrapper.appendChild(toWrap);
    };
    const addButtons = (wrapper) => {
        const minus = document.createElement('div');
        const plus = document.createElement('div');

        minus.classList.add('minus');
        plus.classList.add('plus');
        wrapper.appendChild(minus);
        wrapper.appendChild(plus);
        return [minus, plus];
    };


    if (inputs && inputs.length) {
        inputs.forEach(inp => {
            wrap(inp);

            const [minus, plus] = addButtons(inp.parentNode);

            minus.addEventListener('click', () => {
                let val = parseInt(inp.value, 10);
                inp.value = Math.max(--val, 1);
            })
            plus.addEventListener('click', () => {
                let val = parseInt(inp.value, 10);
                inp.value = ++val;
            })
        });
    }

    /** contact-form send to Mailchimp */
    const forms = document.querySelectorAll('.contact-form');
    const mailchimpFormHtml = `<form style="visibility: hidden; width: 1px; height: 1px; overflow: hidden; opacity: 0;" action="https://rozendal.us6.list-manage.com/subscribe/post?u=2f6cddad2d671ea68aed95aab&amp;id=4e017172e2&amp;f_id=00702be3f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
        
    <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL" required>
    <span id="mce-EMAIL-HELPERTEXT" class="helper_text"></span>
    </div>
    <div id="mce-responses" class="clear foot">
        <div class="response" id="mce-error-response" style="display:none"></div>
        <div class="response" id="mce-success-response" style="display:none"></div>
    </div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_2f6cddad2d671ea68aed95aab_4e017172e2" tabindex="-1" value=""></div>
        <div class="optionalParent">
            <div class="clear foot">
                <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button">
            </div>
        </div>
    </div>
    </form>
    <script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script><script type='text/javascript'>(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[1]='FNAME';ftypes[1]='text';fnames[0]='EMAIL';ftypes[0]='email';}(jQuery));var $mcj = jQuery.noConflict(true);</script>`

    if (forms && forms.length) {
        console.log('GOT forms :>> ', forms);

        const mailchimpForm = document.createElement('div');

        mailchimpForm.innerHTML = mailchimpFormHtml;
        document.body.appendChild(mailchimpForm);

        forms.forEach((form) => {
            form.addEventListener('submit', (e) => {
                console.log('form :>> ', form);
                const email = form.querySelector('input[type="email"]').value;
                
                if (email) {
                    mailchimpForm.querySelector('#mce-EMAIL').value = email;
                    mailchimpForm.querySelector('FORM').submit();
                }
            });
        })
    }
});
